__turbopack_context__.v({
  "bvpGenuinePartLogo": "styles-module__jsMXaG__bvpGenuinePartLogo",
  "hasSymptomsRemark": "styles-module__jsMXaG__hasSymptomsRemark",
  "isuzuGenuinePartLogo": "styles-module__jsMXaG__isuzuGenuinePartLogo",
  "relatedPartItemWrap": "styles-module__jsMXaG__relatedPartItemWrap",
  "symptoms": "styles-module__jsMXaG__symptoms",
  "tripetchGenuinePartLogo": "styles-module__jsMXaG__tripetchGenuinePartLogo",
});
